import * as React from "react";
const SvgSign = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M9 4C9.5525 4 10 4.44775 10 5V8H35C35.55 8 36 8.4475 36 9C36 9.5525 35.55 10 35 10H10V35C10 35.55 9.5525 36 9 36C8.4475 36 8 35.55 8 35V10H5C4.44775 10 4 9.5525 4 9C4 8.4475 4.44775 8 5 8H8V5C8 4.44775 8.4475 4 9 4ZM12 14C12 12.8938 12.8938 12 14 12H32C33.1063 12 34 12.8938 34 14V26C34 27.1063 33.1063 28 32 28H14C12.8938 28 12 27.1063 12 26V14ZM14 26H32V14H14V26Z" }));
export default SvgSign;
